import { atom } from 'jotai';
import { DEFAULT_NUMBERS } from '../mock/numbers';

const numbersFiltersAtom = atom({
  q: '',
}, (get, set, update) => {
  set(numbersFiltersAtom, {
    ...get(numbersFiltersAtom),
    ...update,
  });
});

const myNumbersFiltersAtom = atom({
  q: '',
}, (get, set, update) => {
  set(myNumbersFiltersAtom, {
    ...get(myNumbersFiltersAtom),
    ...update,
  });
});

const selectedNumberAtom = atom(null);

const numbersAtom = atom(DEFAULT_NUMBERS);

export {
  numbersFiltersAtom,
  myNumbersFiltersAtom,
  numbersAtom,
  selectedNumberAtom,
};
